import React, { useState } from 'react';
import { dynamoDb } from '../../awsConfig';
import './UploadVideoForm.css';

const UploadVideoForm = () => {
  const [uploadDate, setUploadDate] = useState('');
  const [Subject, setSubject] = useState('');
  const [videoUrl, setVideoUrl] = useState('');

  const handleUpload = async () => {
    // Prevent selecting a future date
    const today = new Date().toISOString().split('T')[0];
    if (uploadDate > today) {
      alert("You cannot upload a video with a future date.");
      return;
    }

    const newVideo = {
      Date: uploadDate,
      Subject,
      videoUrl,
    };

    try {
      const result = await dynamoDb
        .query({
          TableName: 'videos2',
          KeyConditionExpression: '#Date = :dateValue AND #Subject = :subjectValue',
          ExpressionAttributeNames: {
            '#Date': 'Date',
            '#Subject': 'Subject',
          },
          ExpressionAttributeValues: {
            ':dateValue': newVideo.Date,
            ':subjectValue': newVideo.Subject,
          },
        })
        .promise();

      if (result.Items.length > 0) {
        const confirmOverwrite = window.confirm(
          `A video for Date ${uploadDate} and Subject ${Subject} already exists. Do you want to overwrite it?`
        );
        if (!confirmOverwrite) return;
      }

      await dynamoDb
        .put({
          TableName: 'videos2',
          Item: newVideo,
        })
        .promise();

      alert('Video uploaded successfully!');
    } catch (error) {
      console.error('Error uploading video:', error);
      alert('Error uploading video. Please try again.');
    }
  };

  return (
    <form className="upload-video-form">
      <h2>Upload New Video</h2>
      <label>
        Date:
        <input
          type="date"
          value={uploadDate}
          onChange={(e) => setUploadDate(e.target.value)}
          max={new Date().toISOString().split('T')[0]}
        />
      </label>
      <label>
        Subject:
        <input
          type="text"
          value={Subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Enter Subject"
        />
      </label>
      <label>
        Unlisted YouTube Video URL:
        <input
          type="url"
          value={videoUrl}
          onChange={(e) => setVideoUrl(e.target.value)}
          placeholder="Enter Video URL"
        />
      </label>
      <button type="button" onClick={handleUpload}>
        Upload Video
      </button>
    </form>
  );
};

export default UploadVideoForm;
